import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../shared/services/config.service';

/** TT-260. Where retainage stands on one work order. */
export interface RetainageSummary {
  percent: number | null;
  held: number;
  releasedAt: string | null;
  readyToRelease: boolean;
}

/** TT-260. A work order whose retainage the company can release now. */
export interface RetainageReadyItem {
  workOrderId: string;
  jobName: string;
  percent: number;
  held: number;
  installerName: string | null;
}

/**
 * TT-260 retainage (Paul, 6 Oct): a % held back from each invoice until the
 * company is satisfied, released from a list once everything else is invoiced
 * and approved, then billed by the installer on its own invoice. The server
 * does all the money; these are plain reads and the one Release action.
 */
@Injectable({ providedIn: 'root' })
export class RetainageService {
  constructor(private readonly http: HttpClient) {}

  summary(workOrderId: string): Observable<RetainageSummary> {
    return this.http.get<RetainageSummary>(`${ConfigService.getHost()}/retainage/work-orders/${workOrderId}`);
  }

  ready(): Observable<RetainageReadyItem[]> {
    return this.http.get<RetainageReadyItem[]>(`${ConfigService.getHost()}/retainage/ready`);
  }

  release(workOrderId: string): Observable<{ workOrderId: string; amount: number; itemId: string }> {
    return this.http.post<{ workOrderId: string; amount: number; itemId: string }>(
      `${ConfigService.getHost()}/retainage/work-orders/${workOrderId}/release`,
      {},
    );
  }

  settings(): Observable<{ defaultPercent: number | null }> {
    return this.http.get<{ defaultPercent: number | null }>(`${ConfigService.getHost()}/retainage/settings`);
  }

  setDefault(defaultPercent: number | null): Observable<{ defaultPercent: number | null }> {
    return this.http.put<{ defaultPercent: number | null }>(`${ConfigService.getHost()}/retainage/settings`, {
      defaultPercent,
    });
  }
}
